import './App.css';
import { ConfigProvider } from 'antd';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import zhCN from 'antd/es/locale/zh_CN'
import IndexMy from './components/pages/IndexMy';
import Jckb from './components/pages/jckb';
import Kycg from './components/pages/kycg';
import Hypx from './components/pages/hypx';
import Qqrd from './components/pages/qqrd';
import Detail from './components/pages/detail';
import About from './components/pages/about';
import Search from './components/pages/search';

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{
      token: {
        borderRadius: 6,
      }
    }}>
      <BrowserRouter>
        <Routes>
          <Route path='/jckb' element={<Jckb />}></Route>
          <Route path='/kycg' element={<Kycg />}></Route>
          <Route path='/xxfb' element={<Hypx />}></Route>
          <Route path='/qqrd' element={<Qqrd />}></Route>
          <Route path='/detail' element={<Detail />}></Route>
          <Route path='/about' element={<About />}></Route>
          <Route path='/search' element={<Search />}></Route>

          <Route path='/*' element={<IndexMy />}></Route>
          {/* <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route>
          <Route path='/login' element={<Login />}></Route> */}
        </Routes>

      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
